import Request from "../lib/request";
import uniqueDeviceId from "../lib/generateUniqueDeviceId";
import {browserName, fullBrowserVersion, osName, osVersion} from "react-device-detect";

const baseUrl = process.env.REACT_APP_API_URL;
const platform = process.env.REACT_APP_CLIENT_ID;

const logData = {
  grant_type: "password",
  client_id: process.env.REACT_APP_CLIENT_ID,
  client_secret: process.env.REACT_APP_CLIENT_SECRET,
  scope: "*",
};

export const login = (data) => {

  const params = Object.assign(logData,data);

  return Request({
    method:'post',
    url: baseUrl + '/login',
    data:
    {...params,
      device_info:{
        serial:uniqueDeviceId(),
        platform: platform,
        os_version: `${osName}_${osVersion}`,
        model: `${browserName}_${fullBrowserVersion}`
      }
    }
  });
};

export const register = (data) => {
  const params = Object.assign(logData,data);

  return Request({
    method:'post',
    url: baseUrl + '/register',
    data:{
      ...params,
      device_info:{
        serial:uniqueDeviceId(),
        platform: platform,
        os_version: `${osName}_${osVersion}`,
        model: `${browserName}_${fullBrowserVersion}`
      }
    }
  });
};

export const checkReferenceCode = (phone_number) => {

  return Request({
    method:'get',
    url: baseUrl + '/checkReferenceCode/' + phone_number,
  });
};

export const verify = (data) => {

  return Request({
    method:'post',
    url: baseUrl+'/verify',
    data:data
  })
};


export const forget = (data) => {

  return Request({
    method:'post',
    url: baseUrl +'/resetPassword/create',
    data:data
  })
};

export const forgetVerify = (data) => {

  return Request({
    method:'post',
    url: baseUrl +'/resetPassword/find',
    data:data
  })
};

export const reset = (data) => {

  return Request({
    method:'post',
    url: baseUrl +'/resetPassword/reset',
    data:data
  })
};

export const store = data => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: baseUrl + "/projects/" + projectId + "/tools",
    needToken: true,
    data: data
  });
};

export const updateInfo = (data) => {
  return Request({
    method: "post",
    url: baseUrl + "/users/updateInfo",
    needToken: true,
    data: data
  });
};

export const changePassword = (data) => {
  return Request({
    method: "post",
    url: baseUrl + "/users/changePassword",
    needToken: true,
    data: data
  });
};
